import json from './data.js'
window.json = json
import './spike.js'
import './particle.js'
import './triangle.js'
import './superbeast.js'
